$(document).on('click', '.video-btn-link', function() {
    var videoSrc = $(this).data('video');
    $('body').addClass('video-pop-opened');
    $('#video-pop-ele source').attr('src', videoSrc);
    $('#video-pop-ele')[0].load();
    $('#video-pop-ele')[0].play();
});
$(document).on('click', '#video-pop-ele', function() {
    var parent = $(this).parents('.video-popup');
    console.log('hiiii');
    if (parent.hasClass('video-muted')) {
        $(this)[0].play();
        parent.removeClass('video-muted');
    } else {
        $(this)[0].pause();
        parent.addClass('video-muted');
    }
});

$(document).on('click', '.video-pop-box', function(e) {
    e.stopPropagation();
});

$(document).on('click', '.video-pop-close, .video-popup', function() {
    $('body').removeClass('video-pop-opened');
    $('.video-popup').removeClass('video-muted');
    $('#video-pop-ele source').attr('src', '');
    $('#video-pop-ele')[0].pause();
});